"use client";

import { InlineWidget } from "react-calendly";

export default function CalendlyWidget() {
  return (
    <div className="w-full h-[700px]">
      <InlineWidget
        styles={{ height: "100%", minHeight: "700px" }}
        url="https://calendly.com/d/4z2-y4q-xc2/1-on-1-lead-generation-strategy-call"
      />
    </div>
  );
}
